import React from 'react'

import ToolLayout from '@components/ToolLayout'

/**
 * Entry point that renders the single ToolLayout shell.
 *
 * Platform mode (meridian vs cloudscape) is read once at the root via
 * usePlatformMode and affects only:
 * - Theme/CSS tokens on ToolLayout/NavBar/SideBar
 * - Which tools appear in the menu (supportedPlatforms filter in ToolMenuConfigService)
 *
 * There is no component branching — both modes use the same rendering tree.
 */
const PlatformModeSelector: React.FC<any> = (props) => {
    return <ToolLayout {...props} />
}

export default PlatformModeSelector
